export default __webpack_public_path__ + "static/media/website.b4fe9b5c.svg";